import React from "react";
import { AutocompleteOption } from "@miplatform/components";
import { FilterSidebar } from "@mibuildweb/components";
import { HomeFilter } from "../types";

export const groupByOptions = [
  { label: "None", value: "None" },
  { label: "Builder", value: "builder" },
  { label: "Current Order", value: "latestTemplateName" },
  { label: "Phase", value: "phase" },
];

export const sortByOptions = [
  { label: "None", value: "None" },
  { label: "Start Date", value: "startDate" },
  { label: "Closing Date", value: "closingDate" },
];

const AUTOCOMPLETE_FIELD_MAP = {
  BUILDER_ID: "builderId",
  COMMUNITY_ID: "communityId",
  LATEST_ORDER_HOME_PHASE: "phase",
  CURRENT_TEMPLATE_NAME: "latestTemplateName",
};

const initialHomeFilters: HomeFilter = {
  groupBy: "phase",
  sortBy: "None",
  builderId: "All",
  communityId: "All",
  phase: "All",
  latestTemplateName: "All",
};

export const HomeFilterSidebar: React.FC<HomeFilterSidebarProps> = ({
  customerOptions,
  communityOptions,
  phaseOptions,
  filters,
  onApplyFilters,
  resetFilters,
  orderTemplateOptions,
  loading,
}) => {
  const homeDataFilters = {
    [AUTOCOMPLETE_FIELD_MAP.BUILDER_ID]: {
      field: AUTOCOMPLETE_FIELD_MAP.BUILDER_ID,
      label: "Builder",
      data: customerOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.COMMUNITY_ID]: {
      field: AUTOCOMPLETE_FIELD_MAP.COMMUNITY_ID,
      label: "Community",
      data: communityOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.LATEST_ORDER_HOME_PHASE]: {
      field: AUTOCOMPLETE_FIELD_MAP.LATEST_ORDER_HOME_PHASE,
      label: "Phase",
      data: phaseOptions,
    },
    [AUTOCOMPLETE_FIELD_MAP.CURRENT_TEMPLATE_NAME]: {
      field: AUTOCOMPLETE_FIELD_MAP.CURRENT_TEMPLATE_NAME,
      label: "Current Order",
      data: orderTemplateOptions,
    },
  };

  return (
    <FilterSidebar
      filters={filters}
      initialFilters={initialHomeFilters}
      onApplyFilters={onApplyFilters}
      onResetFilters={resetFilters}
      groupByOptions={groupByOptions}
      sortByOptions={sortByOptions}
      dataFilters={homeDataFilters}
      loading={loading}
      enableSearchParamsSync
    />
  );
};

type HomeFilterSidebarProps = {
  customerOptions: AutocompleteOption[];
  communityOptions: AutocompleteOption[];
  phaseOptions: AutocompleteOption[];
  filters: HomeFilter;
  onApplyFilters: (filters: HomeFilter) => void;
  resetFilters?: () => void;
  orderTemplateOptions: AutocompleteOption[];
  loading?: boolean;
};
